import React from 'react'

export default function UserTableLoader(props) {
    return (
      <div className={`table-squeleton ${(props.display)? "d-block" : "d-none"}`} style={{height:`${props.height? props.height : ""}px`}}>
        <div className="mb-2" style={{height:"60px", background:"#fff", padding:"10px"}}>
            <div className="col col-6 col-xl-2 col-lg-3 fl-l p-0">
                <div className="squeleton w-100" style={{height:"38px"}}></div>
            </div>
            <div className="col col-6 fl-r pr-0 text-right h-100">
                <div className="squeleton d-block squeleton-text w-25 fl-r"><span className="invisible">De 1 à 20 sur 100</span></div>
                <div className="squeleton d-block squeleton-text w-75 fl-r invisible"><span className="invisible">De 1 à 20 sur 100</span></div>
                <div className="squeleton d-block squeleton-text mt-2 fl-r w-10"><span className="invisible">De 1 à 20 sur 100</span></div>
            </div>
        </div>
        <div className="pb-3" style={{background:"#fff", height:"Calc(100% - 65px)"}}>
          <div style={{height:"Calc(100% - 50px)", overflow:"auto", padding:"15px 10px"}}>
              <table className="table table-stripe squeleton-table">
                  <thead>
                      <tr>
                        <th width="33px" className="lang text-center squeleton"></th>
                        <th className="lang text-center squeleton"></th>
                        <th className="lang text-center squeleton"></th>
                        <th className="lang text-center squeleton"></th>
                        <th className="lang text-center squeleton"></th>
                        <th className="lang text-center squeleton"></th>
                        <th className="lang text-center squeleton"></th>
                      </tr>
                  </thead>
                  <tbody className="pr" style={{top:"10px"}}>
                      <tr>
                          <td style={{paddingTop:"19px"}}>
                              <div className="squeleton squeleton-checkbox"></div>
                          </td>
                          <td className={`d-none ${(props.isUserTable)? "d-lg-block" : ""}`}>
                              <div className="d-none d-lg-inline-block va-m">
                                  <div className="d-inline-block assign-profil squeleton squeleton-circle mr-2" style={{border:"4px solid #F2F4F4"}}></div>
                              </div>
                              <div className="d-inline-block squeleton squeleton-text w-50"></div>
                          </td>
                          <td className={`s-u-text d-block ${(props.isUserTable)? "d-lg-none" : ""}`}>
                              <div className="squeleton squeleton-text"></div>
                          </td>
                          <td className="s-u-text">
                              <div className="squeleton squeleton-text"></div>
                          </td>
                          <td className="s-u-text">
                              <div className="squeleton squeleton-text"></div>
                          </td>
                          <td className="s-u-text">
                              <div className="squeleton squeleton-text"></div>
                          </td>
                          <td className="s-u-text text-center">
                              <div className="squeleton squeleton-text"></div>
                          </td>
                          <td className="s-u-text text-center">
                              <div className="squeleton squeleton-text"></div>
                          </td>
                      </tr>
                      <tr>
                          <td style={{paddingTop:"19px"}}>
                              <div className="squeleton squeleton-checkbox"></div>
                          </td>
                          <td className={`d-none ${(props.isUserTable)? "d-lg-block" : ""}`}>
                              <div className="d-none d-lg-inline-block va-m">
                                  <div className="d-inline-block assign-profil squeleton squeleton-circle mr-2" style={{border:"4px solid #F2F4F4"}}></div>
                              </div>
                              <div className="d-inline-block squeleton squeleton-text w-50"></div>
                          </td>
                          <td className={`s-u-text d-block ${(props.isUserTable)? "d-lg-none" : ""}`}>
                              <div className="squeleton squeleton-text"></div>
                          </td>
                          <td className="s-u-text">
                              <div className="squeleton squeleton-text"></div>
                          </td>
                          <td className="s-u-text">
                              <div className="squeleton squeleton-text"></div>
                          </td>
                          <td className="s-u-text">
                              <div className="squeleton squeleton-text"></div>
                          </td>
                          <td className="s-u-text text-center">
                              <div className="squeleton squeleton-text"></div>
                          </td>
                          <td className="s-u-text text-center">
                              <div className="squeleton squeleton-text"></div>
                          </td>
                      </tr>
                      <tr>
                          <td style={{paddingTop:"19px"}}>
                              <div className="squeleton squeleton-checkbox"></div>
                          </td>
                          <td className={`d-none ${(props.isUserTable)? "d-lg-block" : ""}`}>
                              <div className="d-none d-lg-inline-block va-m">
                                  <div className="d-inline-block assign-profil squeleton squeleton-circle mr-2" style={{border:"4px solid #F2F4F4"}}></div>
                              </div>
                              <div className="d-inline-block squeleton squeleton-text w-50"></div>
                          </td>
                          <td className={`s-u-text d-block ${(props.isUserTable)? "d-lg-none" : ""}`}>
                              <div className="squeleton squeleton-text"></div>
                          </td>
                          <td className="s-u-text">
                              <div className="squeleton squeleton-text"></div>
                          </td>
                          <td className="s-u-text">
                              <div className="squeleton squeleton-text"></div>
                          </td>
                          <td className="s-u-text">
                              <div className="squeleton squeleton-text"></div>
                          </td>
                          <td className="s-u-text text-center">
                              <div className="squeleton squeleton-text"></div>
                          </td>
                          <td className="s-u-text text-center">
                              <div className="squeleton squeleton-text"></div>
                          </td>
                      </tr>
                      <tr>
                          <td style={{paddingTop:"19px"}}>
                              <div className="squeleton squeleton-checkbox"></div>
                          </td>
                          <td className={`d-none ${(props.isUserTable)? "d-lg-block" : ""}`}>
                              <div className="d-none d-lg-inline-block va-m">
                                  <div className="d-inline-block assign-profil squeleton squeleton-circle mr-2" style={{border:"4px solid #F2F4F4"}}></div>
                              </div>
                              <div className="d-inline-block squeleton squeleton-text w-50"></div>
                          </td>
                          <td className={`s-u-text d-block ${(props.isUserTable)? "d-lg-none" : ""}`}>
                              <div className="squeleton squeleton-text"></div>
                          </td>
                          <td className="s-u-text">
                              <div className="squeleton squeleton-text"></div>
                          </td>
                          <td className="s-u-text">
                              <div className="squeleton squeleton-text"></div>
                          </td>
                          <td className="s-u-text">
                              <div className="squeleton squeleton-text"></div>
                          </td>
                          <td className="s-u-text text-center">
                              <div className="squeleton squeleton-text"></div>
                          </td>
                          <td className="s-u-text text-center">
                              <div className="squeleton squeleton-text"></div>
                          </td>
                      </tr>
                      <tr>
                          <td style={{paddingTop:"19px"}}>
                              <div className="squeleton squeleton-checkbox"></div>
                          </td>
                          <td className={`d-none ${(props.isUserTable)? "d-lg-block" : ""}`}>
                              <div className="d-none d-lg-inline-block va-m">
                                  <div className="d-inline-block assign-profil squeleton squeleton-circle mr-2" style={{border:"4px solid #F2F4F4"}}></div>
                              </div>
                              <div className="d-inline-block squeleton squeleton-text w-50"></div>
                          </td>
                          <td className={`s-u-text d-block ${(props.isUserTable)? "d-lg-none" : ""}`}>
                              <div className="squeleton squeleton-text"></div>
                          </td>
                          <td className="s-u-text">
                              <div className="squeleton squeleton-text"></div>
                          </td>
                          <td className="s-u-text">
                              <div className="squeleton squeleton-text"></div>
                          </td>
                          <td className="s-u-text">
                              <div className="squeleton squeleton-text"></div>
                          </td>
                          <td className="s-u-text text-center">
                              <div className="squeleton squeleton-text"></div>
                          </td>
                          <td className="s-u-text text-center">
                              <div className="squeleton squeleton-text"></div>
                          </td>
                      </tr>
                  </tbody>
              </table>
          </div>
          <div className="pl-2 bg-i" style={{height:"40px", marginTop:"10px"}}>
              <div className="squeleton mr-2 d-inline-block" style={{height:"30px", width:"27px"}}></div>
              <div className="squeleton mr-2 d-inline-block" style={{height:"30px", width:"27px"}}></div>
              <div className="squeleton mr-2 d-inline-block" style={{height:"30px", width:"27px"}}></div>
              <div className="squeleton mr-2 d-inline-block" style={{height:"30px", width:"27px"}}></div>
              <div className="squeleton mr-2 d-inline-block" style={{height:"30px", width:"27px"}}></div>
          </div>
          </div>
      </div>
    )
  }